import EmbededPeriscope from "../components/EmbededPeriscope";

const prepareMemberRoutes = (sidebar = []) => {
  return sidebar.map(({ logo, name, embedUrl, banner }) => {
    return {
      title: name,
      to: `/${name}`,
      path: `/${name}`,
      logo,
      component: EmbededPeriscope,
      embedUrl,
      banner
    };
  });
};

export default prepareMemberRoutes;
